import { IHttpStatusCodes } from "../models/HttpCodes.model";

export const HttpStatusCodes: IHttpStatusCodes = {
  UNAUTHORIZED: {
    code: 401,
    message: 'UNAUTHORIZED',
    description: 'Acceso no autorizado'
  },
  NOT_ACCEPTABLE: {
    code: 406,
    message: 'NOT_ACCEPTABBLE',
    description: 'Cierre de sesión forzado por cambio de contraseña del usuario'
  }
}

export enum AZURE_CA_URLS {
  GAMIFICACION = 'gamificacion',
  AUTOEVALUACION = 'autoevaluacion',
  INTEGRACIONES = 'integraciones',
  GESTION_TICKETS = 'gestion_tickets',
  CONTENIDO = 'contenido',
  USUARIOS = 'usuarios',
}
